import React, { useEffect, useState, useRef } from 'react';
import './CountdownTimer.css';

const R = 32;
const CIRC = 2 * Math.PI * R;

const CountdownTimer = ({ timeRemaining }) => {
  const [totalTime, setTotalTime] = useState(timeRemaining);
  const initialTime = useRef(timeRemaining);

  useEffect(() => {
    if (timeRemaining === initialTime.current) {
      setTotalTime(timeRemaining);
    }
  }, [timeRemaining]);

  const pct    = totalTime > 0 ? (timeRemaining / totalTime) * 100 : 0;
  const offset = CIRC - (pct / 100) * CIRC;

  const danger  = timeRemaining <= 5;
  const warning = !danger && timeRemaining <= 10;
  const color   = danger ? '#f43f5e' : warning ? '#f97316' : '#22d3ee';

  const svgClass = [
    'cdt-svg',
    danger  ? 'cdt-svg--danger'  : '',
    warning ? 'cdt-svg--warning' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className="cdt-wrap">
      <svg
        width="80" height="80"
        viewBox="0 0 80 80"
        className={svgClass}
      >
        {/* Track */}
        <circle cx="40" cy="40" r={R} fill="none" stroke="#1e293b" strokeWidth="7" />
        {/* Arc */}
        <circle
          cx="40" cy="40" r={R}
          fill="none"
          stroke={color}
          strokeWidth="7"
          strokeDasharray={CIRC}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 40 40)"
          style={{ transition: 'stroke-dashoffset 1s linear, stroke 0.4s' }}
        />
        {/* Number */}
        <text x="40" y="37" textAnchor="middle" dominantBaseline="middle"
          fill="#f1f5f9" fontSize="20" fontWeight="800" fontFamily="inherit">
          {timeRemaining}
        </text>
        {/* Label */}
        <text x="40" y="55" textAnchor="middle" dominantBaseline="middle"
          fill={color} fontSize="9" fontWeight="700" fontFamily="inherit">
          secs
        </text>
      </svg>
    </div>
  );
};

export default CountdownTimer;
